import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { formatData, isNullOrEmpty, showMessageToastCustom, translate } from '../../../../../utils/util';
import { Breadcrumbs, Card, ConfirmButtons, Input, Subtitle } from '../../../../../components/UI/ComponentsUI';
import ScannerCode from '../../../../../components/UI/ScannerCode';
import PabReplanningService from '../../../../../services/PABReplanningService';

const OrderDetail = (props) => {
    const item = props.order ?? {}
    const [pdu, setPdu] = useState('');

    const getSupplierName = (text) => {
        if (!isNullOrEmpty(text)) {
            const supplier = text.trim().split(/\s+/);
            return supplier.slice(0, 2).join(' ');
        }
        else {
            return text;
        }
    };

    const scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            const element = document.getElementById('pdu');
            element.value = value;
            setPdu(value);
        }
    };

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            confirm();
        }
    }

    const confirm = () => {
        if (!isNullOrEmpty(pdu) && pdu === item?.location) {
            props.confirmAllocation(item, () => {
                props.history.go(-1);

            });
        }
        else {
            showMessageToastCustom(translate('general:warning'),
                "Posição Incorreta.",
                3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }
    };

    return (
        <div>
            <Breadcrumbs id="pabOrdes"
                subtitles={[{ icon: "business_center", label: "Missão" }]}
                title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('menu:pabReplanning') }}
            />
            <div className="container" style={{ marginTop: '40px', }}>
                <Subtitle truncate="true" label={`Fornecedor: ${item.supplierCode}-${getSupplierName(item.supplierName)}`} />
                <Card>
                    <div className="row" style={{ marginBottom: '0', paddingBottom: '0' }}>
                        <div className="row">
                            <div className="input-field no-padding col s6">
                                <span className="field f-1p45r truncate">{item?.partNumberCode}</span>
                                <label className="active" htmlFor="entryCode">{translate('line-picking:linepicking.drawing')}</label>
                            </div>
                            <div className="input-field no-padding col s5">
                                <span className="field f-1p45r truncate">{item?.pabOrderCode}</span>
                                <label className="active">{translate('expedition:picking.order')}</label>
                            </div>
                            <div className="input-field no-padding col s6">
                                <span className="field f-1r">{item?.partNumberDescription}</span>
                                <label className="active">{translate('inventory:general.description')}</label>
                            </div>
                            <div className="input-field no-padding col s4">
                                <b><span className="field f-1r truncate">{item?.location}</span></b>
                                <label className="active">{translate('line-picking:linepicking.location')}</label>
                            </div>
                            <div className="input-field no-padding col s6">
                                <span className="field f-1r truncate">{item?.quantity}</span>
                                <label className="active">{translate('change-location:amount')}</label>
                            </div>
                            <div className="input-field no-padding col s4">
                                <span className="field f-1r truncate">{item?.mdrType}</span>
                                <label className="active">{translate('line-picking:linepicking.mdr')}</label>
                            </div>
                            <div className="input-field no-padding col s12">
                                <span className="field f-1r truncate">{formatData(item?.createdOn)}</span>
                                <label className="active">{translate('physical-confirmation:date')} {translate('expedition:picking.order')}</label>
                            </div>
                        </div>
                        <div className="input-field no-padding col s12" style={{ marginTop: '0', paddingTop: '0' }}>
                            <ScannerCode onScanner={scanner} />
                            <Input
                                id='pdu'
                                name='pdu'
                                type="text"
                                required
                                label="Posição"
                                onKeyDown={(e) => handleOnKeyDown(e)}
                                onChange={(event) => setPdu(event.target?.value)}
                                defaultValue={""}
                            />
                        </div>
                    </div>
                    <ConfirmButtons
                        onConfirm={() => confirm()}
                        onCancel={() => props.history.go(-1)}
                    />
                </Card>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        order: state.pabReplanningReducer.order
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmAllocation: (data, callback) => {
            dispatch(PabReplanningService.confirmationPabAllocation(data, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderDetail)));
